var _circle, _circle2, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoGoogleVacationRentalsCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2282_159877",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2282_159877)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2282_159877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6533 11.1364V14.041H16.7721C16.5912 14.975 16.0485 15.766 15.2345 16.2978L17.7182 18.1865C19.1654 16.8774 20.0003 14.9547 20.0003 12.6706C20.0003 12.1387 19.9516 11.6273 19.8611 11.1365L12.6533 11.1364Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.36436 13.9276L7.80417 14.3478L5.82129 15.8614C7.08057 18.3091 9.66156 20.0001 12.6532 20.0001C14.7195 20.0001 16.4519 19.3319 17.7181 18.1865L15.2344 16.2978C14.5525 16.7478 13.6829 17.0205 12.6532 17.0205C10.6634 17.0205 8.97282 15.7046 8.36748 13.9319L8.36436 13.9276Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8214 9.13867C5.29962 10.1477 5.00049 11.2864 5.00049 12.5C5.00049 13.7136 5.29962 14.8523 5.8214 15.8613C5.8214 15.8681 8.36784 13.925 8.36784 13.925C8.21478 13.475 8.12431 12.9977 8.12431 12.4999C8.12431 12.0021 8.21478 11.5249 8.36784 11.0749L5.8214 9.13867Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6534 7.98638C13.7805 7.98638 14.7823 8.36819 15.5824 9.10457L17.774 6.95685C16.4451 5.74323 14.7197 5 12.6534 5C9.66172 5 7.08057 6.6841 5.82129 9.13866L8.36765 11.075C8.97291 9.30228 10.6636 7.98638 12.6534 7.98638Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2282_159877"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoGoogleVacationRentalsCircle);
export default __webpack_public_path__ + "static/media/IcoGoogleVacationRentalsCircle.34c7d05bf92cbd2808b4f89352c416fc.svg";
export { ForwardRef as ReactComponent };